import React from 'react';

/**
 * ImagePlaceholder — zastępuje prawdziwe zdjęcie podczas developmentu.
 *
 * Jak podmienić na prawdziwe zdjęcie:
 * 1. Umieść plik w /public/images/<nazwaPliku>
 * 2. Zamień <ImagePlaceholder> na <img src="/images/<nazwaPliku>" alt="..." />
 *    lub ustaw prop `src` jeśli komponent to obsługuje.
 *
 * Każde wywołanie ma opisowy `label` informujący, jakie zdjęcie tu wstawić.
 */
export default function ImagePlaceholder({ label = 'Zdjęcie', className = '', style = {}, aspectRatio = '4/3' }) {
  return (
    <div
      className={`img-placeholder ${className}`}
      style={{
        aspectRatio,
        width: '100%',
        ...style,
      }}
      aria-label={label}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
        {/* Camera icon */}
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
          <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" />
          <circle cx="12" cy="13" r="4" />
        </svg>
        <span style={{ fontSize: 10, color: 'rgba(148,163,184,0.5)', textAlign: 'center', maxWidth: 140, lineHeight: 1.4 }}>
          {label}
        </span>
        <span style={{ fontSize: 9, color: 'rgba(59,130,246,0.4)', marginTop: 2 }}>
          /public/images/
        </span>
      </div>
    </div>
  );
}
